// Options for the "Key Outcomes (check all that apply)" field on the
// CodePRep drill submission form. Values are sent verbatim to the API.
export const drillKeyOutcomes = [
  { value: "Improved response time", label: "Improved response time" },
  { value: "Better team coordination", label: "Better team coordination" },
  {
    value: "Improved CPR quality (rate, depth, recoil)",
    label: "Improved CPR quality (rate, depth, recoil)",
  },
  {
    value: "Faster AED / defibrillator application",
    label: "Faster AED / defibrillator application",
  },
  { value: "Clearer role assignment", label: "Clearer role assignment" },
  {
    value: "Improved closed-loop communication",
    label: "Improved closed-loop communication",
  },
  {
    value: "Identified equipment or supply gaps",
    label: "Identified equipment or supply gaps",
  },
  {
    value: "Increased team confidence",
    label: "Increased team confidence",
  },
  { value: "Other", label: "Other" },
];
